/**
 * アンカーリンク（目次）のスクロール修正
 *
 * 問題:
 *   - 初回ロード時に画像 lazy load 前の Y 座標で scroll するため、target を通り過ぎる
 *   - sticky header の高さ分、target がヘッダーに隠れる
 *   - target 直下の lazy 画像が遅延 load されると、着地後にも位置がずれる
 *
 * 対策:
 *   1. クリック時に scrollIntoView 相当の動作を上書き
 *   2. target の前後 ±500px にある lazy 画像を eager 化（範囲拡大）
 *   3. sticky header の高さを実測して scroll offset で補正
 *   4. target 周辺の画像 load イベントで 1 回だけ追加再補正
 *   5. 安定判定後も短時間モニタリング
 */
(function () {
  'use strict';

  var SCROLL_DELAY_MS = 50;
  var RECHECK_INTERVAL_MS = 200;
  var MAX_RECHECK = 20;  // 4 秒間モニタリング
  var EAGER_RANGE_PX = 500;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getTarget(hash) {
    if (!hash || hash.length < 2 || hash === '#MainContent') return null;
    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return null;
    }
  }

  /**
   * sticky header の現在の高さを実測。
   * dawn 系の sticky-header / .header-wrapper(.sticky) を対象。
   */
  function getStickyOffset() {
    var candidates = document.querySelectorAll('sticky-header, .shopify-section-header-sticky, .header-wrapper');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var style = window.getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'sticky') {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.top <= 0.5) {
          return rect.height;
        }
      }
    }
    return 0;
  }

  /**
   * target の前後 ±EAGER_RANGE_PX にある lazy 画像を eager 化。
   * これにより画像 load 完了が早まり、target Y 座標が早く確定する。
   */
  function eagerizeLazyImagesAround(target) {
    var targetY = target.getBoundingClientRect().top + window.scrollY;
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    var watched = [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var imgY = img.getBoundingClientRect().top + window.scrollY;
      if (imgY >= targetY - EAGER_RANGE_PX && imgY <= targetY + EAGER_RANGE_PX) {
        img.loading = 'eager';
        if (!img.complete) watched.push(img);
      }
    }
    return watched;
  }

  function scrollToTarget(target, smooth) {
    var offset = getStickyOffset();
    var y = target.getBoundingClientRect().top + window.scrollY - offset - 8;
    if (y < 0) y = 0;
    try {
      window.scrollTo({
        top: y,
        behavior: (smooth && !prefersReducedMotion) ? 'smooth' : 'auto',
      });
    } catch (e) {
      // 古いブラウザ fallback
      window.scrollTo(0, y);
    }
  }

  /**
   * target 要素が想定位置（offset + 8px 下）に来るまで、
   * 画像 load の進行に合わせて再スクロール。
   */
  function scrollWithRecheck(target) {
    var watched = eagerizeLazyImagesAround(target);
    scrollToTarget(target, false);

    // 画像 load イベントで 1 回だけ追加補正
    watched.forEach(function (img) {
      img.addEventListener('load', function onLoad() {
        img.removeEventListener('load', onLoad);
        scrollToTarget(target, false);
      }, { once: true });
    });

    // ユーザーが手動でスクロール/操作したら recheck を即停止
    // （これがないと recheck 中はスクロールロックされて感じる）
    var manualScrolled = false;
    function onManualScroll() { manualScrolled = true; }
    var manualEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    manualEvents.forEach(function (ev) {
      window.addEventListener(ev, onManualScroll, { capture: true, passive: true });
    });

    var count = 0;
    var lastTop = null;
    var expectedOffset = getStickyOffset() + 8;
    var timer = setInterval(function () {
      if (manualScrolled) {
        clearInterval(timer);
        manualEvents.forEach(function (ev) {
          window.removeEventListener(ev, onManualScroll, { capture: true });
        });
        return;
      }
      var rect = target.getBoundingClientRect();
      var top = Math.round(rect.top);
      // target が想定位置近傍（expectedOffset ± 4px）で安定したら終了
      if (
        lastTop !== null &&
        Math.abs(top - lastTop) < 2 &&
        Math.abs(top - expectedOffset) < 8
      ) {
        clearInterval(timer);
        manualEvents.forEach(function (ev) {
          window.removeEventListener(ev, onManualScroll, { capture: true });
        });
        return;
      }
      lastTop = top;
      // expectedOffset は sticky header の高さが変動する可能性に備えて再計算
      expectedOffset = getStickyOffset() + 8;
      scrollToTarget(target, false);
      count++;
      if (count >= MAX_RECHECK) {
        clearInterval(timer);
        manualEvents.forEach(function (ev) {
          window.removeEventListener(ev, onManualScroll, { capture: true });
        });
      }
    }, RECHECK_INTERVAL_MS);
  }

  /* ─── クリック時の動作上書き ─── */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIdx = href.indexOf('#');
    if (hashIdx < 0) return;
    var path = href.slice(0, hashIdx);
    if (path && path !== window.location.pathname && path !== window.location.href.split('#')[0]) return;
    var hash = href.slice(hashIdx);
    var target = getTarget(hash);
    if (!target) return;

    e.preventDefault();
    eagerizeLazyImagesAround(target);
    scrollToTarget(target, true);
    if (history.replaceState) history.replaceState(null, '', hash);
    setTimeout(function () { scrollWithRecheck(target); }, 600);
  });

  /* ─── 初回ロード時の hash 対応 ─── */
  if (window.location.hash && window.location.hash.length > 1) {
    var initialTarget = getTarget(window.location.hash);
    if (initialTarget) {
      window.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
          scrollWithRecheck(initialTarget);
        }, SCROLL_DELAY_MS);
      });
    }
  }
})();
